import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/icons/blog-new.tsx
function r({ colors: r, style: i, ...a }) {
	return /* @__PURE__ */ n("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(r),
			...i
		},
		...a,
		children: [
			/* @__PURE__ */ t("path", {
				d: "M4.99219 15.0217H7.6875C8.18371 15.0217 8.58594 14.6194 8.58594 14.1232C8.58594 13.627 8.18371 13.2248 7.6875 13.2248H4.99219C4.49598 13.2248 4.09375 13.627 4.09375 14.1232C4.09375 14.6194 4.49598 15.0217 4.99219 15.0217Z",
				fill: "var(--icon-color-primary, currentColor)"
			}),
			/* @__PURE__ */ t("path", {
				d: "M4.99219 11.4279H7.6875C8.18371 11.4279 8.58594 11.0257 8.58594 10.5295C8.58594 10.0333 8.18371 9.63105 7.6875 9.63105H4.99219C4.49598 9.63105 4.09375 10.0333 4.09375 10.5295C4.09375 11.0257 4.49598 11.4279 4.99219 11.4279Z",
				fill: "var(--icon-color-primary, currentColor)"
			}),
			/* @__PURE__ */ t("path", {
				d: "M10.2679 14.1232C10.2679 14.6194 10.6701 15.0217 11.1663 15.0217C13.045 15.0217 14.8112 14.2901 16.1396 12.9616L22.7099 6.39074C23.7632 5.33746 23.7634 3.63245 22.7099 2.57899C21.6591 1.52808 19.9491 1.52808 18.8982 2.57899L12.3279 9.14989C10.9995 10.4784 10.2679 12.2446 10.2679 14.1232ZM20.1688 3.8496C20.519 3.4993 21.0891 3.4993 21.4393 3.8496C21.7904 4.20062 21.7906 4.76902 21.4393 5.12017L14.869 11.6911C14.118 12.4422 13.1789 12.937 12.1579 13.1316C12.3525 12.1107 12.8474 11.1716 13.5984 10.4205L20.1688 3.8496Z",
				fill: "var(--icon-color-primary, currentColor)"
			}),
			/* @__PURE__ */ t("path", {
				d: "M3.19531 22.2092C3.85908 22.2092 4.49706 21.9656 4.99183 21.5232L6.23378 20.4123H15.4141C17.8911 20.4123 19.9062 18.3971 19.9062 15.9201V13.9048C19.9062 13.4086 19.504 13.0063 19.0078 13.0063C18.5116 13.0063 18.1094 13.4086 18.1094 13.9048V15.9201C18.1094 17.4063 16.9003 18.6154 15.4141 18.6154H5.89062C5.66961 18.6154 5.45637 18.6969 5.29164 18.8442L3.79403 20.1838C3.62921 20.3312 3.4166 20.4123 3.19531 20.4123C2.69991 20.4123 2.29688 20.0093 2.29688 19.5139V8.73261C2.29688 7.24642 3.50599 6.0373 4.99219 6.0373H12.5278C13.024 6.0373 13.4262 5.63507 13.4262 5.13886C13.4262 4.64266 13.024 4.24043 12.5278 4.24043H4.99219C2.51515 4.24043 0.5 6.25562 0.5 8.73261V19.5139C0.5 21.0001 1.70912 22.2092 3.19531 22.2092Z",
				fill: "var(--icon-color-primary, currentColor)"
			})
		]
	});
}
//#endregion
export { r as BlogNewIcon };
